import * as React from "react";
import {Subscription} from "@falcon/services";
import * as moment from "moment";

interface IProps {
    subscription: Subscription
}

export class SubscriptionEndBanner extends React.Component<IProps> {

    public render() {
        const endDate: moment.Moment = moment.utc(this.props.subscription.currentPeriodEndDate, moment.ISO_8601);
        let wording : string;
        const dateIsToday : boolean = endDate.isSame(moment(), 'day');

        if (dateIsToday) {
            wording = "Your subscription ends today"
        } else if (endDate.isBefore(moment(), 'day')) {
            wording = "Your subscription was cancelled on";
        } else {
            wording = "Your subscription will end on";
        }

        return (
            <div id="subscriptionEndBanner" className="banner">
                <img src="/img/alert-orange.svg" alt="Orange alert icon"/>
                <div className="banner-text">
                    {wording}{!dateIsToday && <b> {endDate.format("D MMMM YYYY")}</b>}. {' '}
                    {/* Disabling the below code due to subscription product discontinuation */}
                    {/*{(!this.props.subscription.cancellationUWFailure && !this.props.subscription.allMTCsAreFromSupportPortal) && (*/}
                    {/*    <Link to="/journey/show/product/FlowSubscription/process/mtaReinstateSubscription/initializeInteraction" id="reactivateSubscription">*/}
                    {/*        Reactivate my subscription.*/}
                    {/*    </Link>*/}
                    {/*)}*/}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/banners/SubscriptionEndBanner.tsx